import { useEffect } from 'react';

export interface MetaProps {
  title: string;
  brand?: string;
}

export const Meta: React.FC<MetaProps> = (props) => {
  const { title, brand } = props;

  const fullTitle = title
    ? `${title} - ${brand || 'Exercise.com'}`
    : `${brand || 'Exercise.com'}`;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return null;
};
